import React from 'react';
import { injectIntl } from 'react-intl';
import { gql } from 'graphql-tag';
import { flowRight as compose } from 'lodash';
import PricingForm from '../../../../components/SiteAdmin/Pricing/PricingForm';
import Loader from '../../../../components/Common/Loader/Loader';
import NotFound from '../../../../components/NotFound/NotFound';
import getPricingQuery from './getPricingQuery.graphql';
import messages from '../../../../locale/messages';
import { withQuery } from '../../../../hoc/withGraphql';

class EditPricing extends React.Component {

  static defaultProps = {
    pricing: {
      loading: true
    }
  };

  render() {
    const { id, pricing: { loading, getPricing }, locations, categories, subCategories } = this.props;
    const { formatMessage } = this.props.intl;
    let initialValues = {};

    // if (!loading && getPricing && getPricing.result) {
    //   initialValues = getPricing && getPricing.result;
    //   initialValues['isActive'] = initialValues['isActive'] && initialValues['isActive'];
    //   initialValues['isPriceEditable'] = initialValues['isPriceEditable'] && initialValues['isPriceEditable'];
    // }

    if (!loading && getPricing && getPricing.result) {
      const result = getPricing.result;

      initialValues = {
        ...result,
        isActive: !!result.isActive,
        isPriceEditable: !!result.isPriceEditable
      };
    }

    if (!loading && !getPricing?.result?.id) {
      return <NotFound title={formatMessage(messages.pageNotFound)} />;
    } else {
      return (
        <Loader type={"page"} show={loading}>
          {
            !loading && <PricingForm id={id}
              initialValues={initialValues}
              locations={locations}
              categories={categories}
              subCategories={subCategories}
            />
          }
        </Loader>
      );
    }
  }
}

export default compose(
  injectIntl,
  withQuery(getPricingQuery, {
    name: 'pricing',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only',
      variables: {
        id: parseInt(props.id)
      }
    })
  }),
  withQuery(gql`
    query {
      getAllLocation {
          results {
              id
              locationName
              isActive
          }
          status
      }
    }`, {
    name: 'locations',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only'
    })
  }),
  withQuery(gql`
      query {
        getActiveCategories {
        results{
            id
            name
            pricingType
        }
        status
      }
    }`, {
    name: 'categories',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only'
    })
  }),
  withQuery(gql`
      query {
        getActiveSubCategories {
        results{
            id
            name
            categoryId
        }
        status
      }
    }`, {
    name: 'subCategories',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only'
    })
  }),
)(EditPricing);
